<template>
<div>
    <HeadDetailsGama  @nextstatus="$emit('nextstatus')" :titleHead="'Lista de Chamados'"></HeadDetailsGama>
    <div id="body-details">
        <div id="head-details input-search" class="pt-2">
            <div class="icon-adjustment">
                <i aria-hidden="true" class="fas fa-search icon-search"></i>
                <input placeholder="Pesquisar log" class="form-control" v-model="serachiput">
            </div>
        </div>
        <div id="tablog" class="mt-4 ml-2">
        <div v-if="serachiput.length == ''">
            <div v-for="data in logAll" :key="data.id">
                <div class="d-flex flex-row mt-1 ml-2" style="font-family:'Segoe UI'">
                    <div class="linhaAling">
                        <div class="ballCrzy">
                            <div class="textNum">{{data.diaFormatado}}</div>
                            <div class="textNum">{{data.mesFormatado}}</div>
                        </div>
                        <div class="linhaSolid"></div>
                    </div>
                    <div class ="ml-3 mt-3">
                        <div class="squareCrzy">
                            <div class="Textneg"> {{data.titulo}} </div>
                            <div class="Textneg2">
                                <div class="description-log">
                                    <i class="fas fa-user-circle" style="scale: 1.25" ></i>{{data.conta.nome}}
                                </div>
                                <div class="description-log">
                                    <i class="far fa-clock" style="scale: 1.25"></i>{{data.dataFormatada}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div v-if="data.ultimoLog">
                <div class="d-flex flex-row mt-1 ml-2">
                    <div class="linhaAling">
                        <div class="ballCrzy">
                            <div class="fas fa-check ballCrzyDone"></div>
                        </div>
                    </div>
                </div>
             </div> -->
            </div>
            </div>
            <div v-else>
                <div v-for="data in logallfilter" :key="data.id">
                <div class="d-flex flex-row mt-1 ml-2">
                    <div class="linhaAling">
                        <div class="ballCrzy">
                            <div class="textNum">{{data.diaFormatado}}</div>
                            <div class="textNum">{{data.mesFormatado}}</div>
                        </div>
                        <div class="linhaSolid"></div>
                    </div>
                    <div class ="ml-3 mt-3">
                        <div class="squareCrzy">
                            <div class="Textneg"> {{data.titulo}} </div>
                            <div class="Textneg2">
                                <i class="far fa-clock"> {{data.dataFormatada}} </i>
                                <i class="ml-2 fas fa-user-circle"> {{data.conta.nome}} </i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>

</div>
</template>

<script>
import logOcurrence from './logOcurrence'
export default logOcurrence
</script>

<style scoped>
#greenChange {
    color: #008148;
}

.ballCrzy {
    width: 50px;
    height: 50px;
    border-radius:50%;
    border: 3px solid;
    font-size: 16px;
}

.ballCrzyDone {
    display: flex;
    justify-content: center;
    padding-top: 13px;
    font-size: 20px;
}

.squareCrzy {
    width: 520px;
    height: 110px;
    background: rgb(243, 241, 241);
    border-radius:1px 15px 15px;
    color: #111;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 1rem 1rem 2rem;
    box-shadow: 10px 10px 5px 0px #d2d2d2;
    font-family: 'Segoe UI';
    display: flex;
    justify-content: space-between;
}

.textNum{
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}

.Textneg2 {
    font-size: 12px;
    color:rgb(116, 121, 116);
    font-family:'Segoe UI';
    font-weight: bold;
    display: flex;
    flex-direction: column;
}

.Textneg {
    font-weight: bold;
    font-size: 20px;
    color:#008148;
}

.linhaSolid {
    height: 125px;
    border-left: 2px solid;
}

.icon-adjustment {
    display: flex;
    align-items: baseline;
    border-radius: 5px;
    gap: 0.5rem;
    position: relative;
    width: 20rem;
    border-radius: 5px;
}

/* .form-control{
    display: block;
    width: 20rem;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color:transparent;
    background-clip: padding-box;
    border: 1px none;
    border-radius: 0;
    padding-left: 5px;
} */

.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 5px;
    padding-left: 30px;
    }
.linhaAling{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    color: #008148;
}

#tablog{
    height: 100%;
}

.description-log {
    display: flex;
    gap: 1rem;
    font-family:'Segoe UI';
    align-items: center;
}
.input-search{
    width: 100%;
    display: flex;
    position: relative;
    gap: 1rem;
}

.icon-search{
    position: absolute;
    left: 10px;
    top: 10px;
    font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/logOcorrence/logOcurrence.vue